// button.component.js
import React from 'react';
import './styles.scss';
//import { Link } from 'React/components';

import { ReactComponent as LinkedinIcon } from 'Icons/linkedin.svg';
import { ReactComponent as FacebookIcon } from 'Icons/facebook.svg';
import { ReactComponent as TwitterIcon } from 'Icons/social_media/twitter-x.svg';
import { ReactComponent as WhatsappIcon } from 'Icons/whatsapp.svg';

const rrssDataLayer = (event) => {
    var rrss = event.currentTarget.attributes['data-rrss'].value

    window.dataLayer.push({
        event: "ga_event",
        event_name: "share",
        event_category: "share",
        event_action: rrss.toLowerCase().normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize(),
        event_label: undefined,
        event_value: undefined,
        option: rrss.toLowerCase().normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()
    })
}

const ShareSocial = ({ title, seoTitle, socialShareTextTwiter, socialShareAccionaTwitterAccount }) => {
    if (typeof window !== 'undefined') {
        var url = "https://api.whatsapp.com/send?text=" + seoTitle + " " + window.location.href;
        return (
            <div className="module grid module-sharesocial">
                <div className="module-sharesocial-container grid full-width">
                    <h2 className="title--s">{title}</h2>
                    <nav className="sharesocial-nav">
                        <a href="javascript:;" onClick={rrssDataLayer} data-rrss="LinkedIn" className="st_linkedin_custom" st_title={seoTitle} st_image=""><LinkedinIcon /></a>
                        <a href="javascript:;" onClick={rrssDataLayer} data-rrss="FaceBook" className="st_facebook_custom" st_title={seoTitle} ><FacebookIcon /></a>
                        <a href="javascript:;" onClick={rrssDataLayer} data-rrss="Twitter" className="st_twitter_custom" st_title={socialShareTextTwiter ? socialShareTextTwiter : seoTitle} st_via={socialShareAccionaTwitterAccount ? socialShareAccionaTwitterAccount : ''} ><TwitterIcon width="14" height="14" /></a>
                        <a href={url} onClick={rrssDataLayer} data-rrss="WhatsApp" className="link mobile-visible" target="_blank"><WhatsappIcon /></a>
                    </nav>
                </div>
            </div>
        );
    }
    else {
        return (
            <>
            </>
        );
    }
};


export default ShareSocial;
